<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">View Detail</span>
      </v-card-title>

      <v-card-text>
        <div v-if="loading" class="d-flex justify-center py-8">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <v-container v-else-if="editedItem">
          <data-detail-row
            label="Bill Number"
            :data="editedItem"
            :valueData="editedItem.bill_num"
            noGutters
          />
          <data-detail-row
            label="Kode Iuran"
            :data="editedItem"
            :valueData="editedItem.kode_iuran"
            noGutters
          />
          <data-detail-row
            label="Merchant Name"
            :data="editedItem"
            :valueData="editedItem.merchant_name"
            noGutters
          />
          <data-detail-row
            label="MID"
            :data="editedItem"
            :valueData="editedItem.mid"
            noGutters
          />
          <data-detail-row
            label="Merchant PAN"
            :data="editedItem"
            :valueData="editedItem.mpan"
            noGutters
          />
          <data-detail-row
            label="Reff ID"
            :data="editedItem"
            :valueData="editedItem.rrn"
            noGutters
          />
          <data-detail-row
            label="QR Method"
            :data="editedItem"
            :valueData="editedItem.qr_method"
            noGutters
          />
          <data-detail-row
            label="QR Type"
            :data="editedItem"
            :valueData="editedItem.qr_type"
            noGutters
          />
          <data-detail-row
            label="Transaction Type"
            :data="editedItem"
            :valueData="editedItem.trx_type"
            noGutters
          />
          <data-detail-row
            label="Issuer Name"
            :data="editedItem"
            :valueData="editedItem.issuer_name"
            noGutters
          />
          <data-detail-row
            label="Customer PAN"
            :data="editedItem"
            :valueData="editedItem.customer_pan"
            noGutters
          />
          <data-detail-row
            label="Customer Name"
            :data="editedItem"
            :valueData="editedItem.customer_name"
            noGutters
          />
          <data-detail-row
            label="Payment Type"
            :data="editedItem"
            :valueData="editedItem.payment_type"
            noGutters
          />
          <data-detail-row
            label="Acquirer Name"
            :data="editedItem"
            :valueData="editedItem.payment_channel"
            noGutters
          />
          <data-detail-row
            label="Amount"
            :data="editedItem"
            :valueData="editedItem.amount"
            noGutters
          />
          <data-detail-row
            label="JHT"
            :data="editedItem"
            :valueData="editedItem.jht"
            noGutters
          />
          <data-detail-row
            label="JKK"
            :data="editedItem"
            :valueData="editedItem.jkk"
            noGutters
          />
          <data-detail-row
            label="JKM"
            :data="editedItem"
            :valueData="editedItem.jkm"
            noGutters
          />
          <data-detail-row
            label="JP"
            :data="editedItem"
            :valueData="editedItem.jp"
            noGutters
          />
          <data-detail-row
            label="JKP"
            :data="editedItem"
            :valueData="editedItem.jkp"
            noGutters
          />
          <data-detail-row
            label="MDR"
            :data="editedItem"
            :valueData="editedItem.amount_mdr"
            noGutters
          />
          <data-detail-row
            label="Net Amount"
            :data="editedItem"
            :valueData="editedItem.net_amount"
            noGutters
          />
          <data-detail-row
            label="Transaction Date"
            :data="editedItem"
            :valueData="editedItem.trx_datetime"
            noGutters
          />
          <data-detail-row
            label="Status"
            :data="editedItem"
            :valueData="editedItem.status"
            noGutters
          />
          <data-detail-row
            label="Settlement Status"
            :data="editedItem"
            :valueData="editedItem.settlement_status"
            noGutters
          />
          <data-detail-row
            label="Settlement Date"
            :data="editedItem"
            :valueData="editedItem.settlement_at"
            noGutters
          />
          <data-detail-row
            label="Source of Fund"
            :data="editedItem"
            :valueData="editedItem.payment_method"
            noGutters
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  components: {
    DataDetailRow: () => import('../detail/DataDetailRow.vue'),
  },
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('closeParent');
    },
  },
};
</script>
